import { getLocale } from './helpers';

const DEFAULT_VALUE = 1236.36;

const _getPart = (value: number, type: string) => {
    const options: Intl.NumberFormatOptions = {
        style: 'decimal',
        maximumFractionDigits: 2,
    };
    const defaultParts = Intl.NumberFormat(getLocale(), options).formatToParts(value);
    const part = defaultParts.find((part) => part.type === type);
    if (part) {
        return part.value;
    }
    return '';
};

export const getDecimalSeparator = (value: number = DEFAULT_VALUE) => _getPart(value, 'decimal');
export const getGroupSeparator = (value: number = DEFAULT_VALUE) => _getPart(value, 'group');

const _getNumber = (amount?: number | string) => {
    const clearStr = (amount ?? '0').toString().trim();
    const group = getGroupSeparator();
    const decimal = getDecimalSeparator();
    const finalClearStr = group !== '.' ? clearStr.replace(group, '').replace(decimal, '.') : clearStr.replace(decimal, '.');
    return finalClearStr ? Number(finalClearStr) : 0;
};
export const _currencyFormat = (
    number: number,
    currencyISO: string,
    currencyDisplay: Intl.NumberFormatOptions['currencyDisplay'],
    maximumFractionDigits = 2,
): string => {
    const options: Intl.NumberFormatOptions = {
        style: 'currency',
        currency: currencyISO,
        currencyDisplay: currencyDisplay,
        maximumFractionDigits: maximumFractionDigits,
    };

    const formatter = new Intl.NumberFormat(getLocale(), options);
    const parts = formatter.formatToParts(_getNumber(number));

    let formattedString = '';
    for (const part of parts) {
        if (part.type === 'currency') {
            formattedString += `${part.value.trim()} `;
        } else {
            formattedString += part.value;
        }
    }

    return formattedString.trim().replace(/\s+/g, ' ');
};

export const significantDecimalPlaces = (value: number): number => {
    const strValue = value?.toString() ?? '0';
    const decimalIndex = strValue.indexOf('.');
    if (decimalIndex === -1) {
        return 0;
    }
    const decimalPart = strValue.slice(decimalIndex + 1);
    const trimmedDecimalPart = decimalPart.replace(/0+$/, '');
    return trimmedDecimalPart.length;
};

export const currencyFormat = (
    amount?: number | string,
    currencyISO?: string,
    maximumFractionDigits = 2,
    currencyDisplay?: Intl.NumberFormatOptions['currencyDisplay'],
): string | Intl.NumberFormatPart[] => {
    try {
        return currencyISO ? _currencyFormat(_getNumber(amount), currencyISO, currencyDisplay ?? 'narrowSymbol', maximumFractionDigits) : numberFormat(amount);
    } catch (e) {
        console.error(e);
        return numberFormat(amount);
    }
};
export const numberFormat = (amount?: number | string, maximumFractionDigits = 2, useFormatToParts = false): string | Intl.NumberFormatPart[] => {
    const options: Intl.NumberFormatOptions = {
        style: 'decimal',
        maximumFractionDigits: maximumFractionDigits,
    };

    const amountNumber = _getNumber(amount);

    const num = useFormatToParts
        ? Intl.NumberFormat(getLocale(), options).formatToParts(amountNumber)
        : Intl.NumberFormat(getLocale(), options).format(amountNumber);
    return num === 'NaN' ? '' + amount : num;
};
